__turbopack_context__.v({
  "className": "cinzel_64c18bfe-module__M13Q1W__className",
  "variable": "cinzel_64c18bfe-module__M13Q1W__variable",
});
